<template>
    <v-card>
        <v-data-table
            v-if="custom_emails"
            :headers="table_headers"
            :items="custom_emails"
            :search="search"
            hide-actions
        >
            <template v-slot:items="props">
            <tr style="cursor: pointer;" @click="updateEmail(props.item)">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ DEFINES.CUSTOM_EMAILS.TYPE_STR[props.item.mail_type] }}
                    <v-chip small color="lightteal" outline >{{ props.item.updated_at?'Customized':'Default' }}</v-chip>
                </td>
                <td class="text-xs-left">
                    <span v-if="props.item.is_active" class="lightteal--text font-weight-bold">Active</span>
                    <span v-else class="red--text font-weight-bold">Inactive</span>
                </td>
                <td class="text-xs-center">
                    <v-tooltip slot="append" top color="white">
                        <v-btn
                        slot="activator"
                        icon
                        small
                        dark
                        @click="updateEmail(props.item)"
                        >
                        <v-icon color="secondary"
                            >$vuetify.icons.rms_visibility</v-icon
                        >
                        </v-btn>
                        <span class="greyDarken3--text body-1">
                        {{ $t("rms.tooltip.view") }}
                        </span>
                    </v-tooltip>
                </td>
            </tr>
            </template>
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    {{
                    $t("rms.alert.search_not_found", {
                        search: this.search,
                    })
                    }}
                </v-alert>
            </template>
        </v-data-table>
        <CustomizeEmail 
            :email="email" 
            :dialog="emailDialog" 
            @reset="reset"
            @refresh="getCustomEmailList">
        </CustomizeEmail>
    </v-card>
</template>

<script>
import {mapState} from 'vuex';
import CustomizeEmail from "@/components/company/CustomizeEmail";

export default {
  name: 'CustomEmailsSetting',
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  components:{
    CustomizeEmail
  },
  data() {
    return {
        search: "",
        table_headers: [
            {
                text: this.$t("rms.table.header.sn"),
                align: "left",
                sortable: false,
            },
            {
                text: 'Email Type',
                align: "left",
                sortable: true,
                value:'mail_type'
            },
            {
                text: 'Status',
                align: "left",
                sortable: false,
                value:'is_active'
            },
            {
                text: this.$t("rms.table.header.action"),
                sortable: false,
                align: "center",
            },
        ],
        custom_emails: [],
        email:null,
        emailDialog:false
    };
  },
  mounted() {
    this.getCustomEmailList();
  },
  methods:{
    updateEmail(email){
        this.email = email;
        this.emailDialog = true;
    },
    reset(){
        this.emailDialog = false;
        this.email = null;
    },
    async getCustomEmailList() {
      try {
        var response = await this.$store.dispatch('company/listCustomEmail',
          {
            company_id: this.company.id,
          }
        );

        this.processEmails(response.emails.data);
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },

    processEmails(savedEmails) {
      var DefaultEmails = this.DEFINES.CUSTOM_EMAILS.TYPES;
      var SaveEmails = savedEmails;

      DefaultEmails.forEach((def) => {
        var isAvail = false;
        SaveEmails.forEach((save) => {
          if (def.mail_type == save.mail_type) {
            isAvail = true;
            return;
          }
        });

        if (!isAvail) {
          savedEmails.push(def);
        }
      });

      this.custom_emails = savedEmails;
    },
  }
}
</script>

<style>

</style>